module.exports = __webpack_public_path__ + "img/ESP.9b8c6391.svg";